import React, { PureComponent } from 'react'
import { Table, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import ExtraSaleModalPage from '../../../containers/masters/ExtraSaleModalPage'
import SimpleTreeSelect from '../../commons/simpleForm/SimpleTreeSelect'
import MapSectionsMasters from '../../../util/map-sections-masters'

class ExtraSaleMasters extends PureComponent {
  constructor () {
    super()
    this.state = {
      uoId: null
    }
  }

  handleOrganizedUnitChange (uoId) {
    this.setState({ uoId })
    this.props.actions.fetchExtraSalesMasters(uoId)
  }

  render () {
    const {
      t, extraSalesMastersList,
      actions: { deleteExtraSaleModal, openExtraSaleModal, recoverExtraSaleModal },
      combos: { UOTreeCombo }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'extraSaleMastersPage' })
    const tKey = 'MASTERS.EXTRA_SALE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    return (
      <div id='extraSaleMasters' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            {this.state.uoId && (
              <Button
                className="_Btn new"
                onClick={() => openExtraSaleModal(this.state.uoId)}>
                {t('MASTERS.ADD')}
              </Button>
            )}
          </div>
          <div className='filters'>
            <div className="search-form">
              <SimpleTreeSelect
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                options={UOTreeCombo}
                searchPlaceholder={t(`${tKey}ORGANIZED_UNIT`)}
                value={this.state.uoId ? this.state.uoId.toString() : null}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                className='dashboard-select'
                customClass='marg-top-15'
              />
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th>{t('MASTERS.ID')}</th>
                    <th>{t('MASTERS.NAME')}</th>
                    <th>{t('MASTERS.DESCRIPTION')}</th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {extraSalesMastersList && extraSalesMastersList.map((extraSaleMaster, idx) => (
                    <tr key={idx} className={extraSaleMaster.isDeleted && 'is-deleted'}>
                      <td>{extraSaleMaster.id}</td>
                      <td>{extraSaleMaster.name}</td>
                      <td>{extraSaleMaster.description}</td>
                      <td className='actions'>
                        {!extraSaleMaster.isDeleted ? (
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openExtraSaleModal(this.state.uoId, extraSaleMaster.id)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteExtraSaleModal(this.state.uoId, extraSaleMaster.id)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <div>
                            <OverlayTrigger placement="left" overlay={recoverTooltip}>
                              <a className='_Btn accent stk o-icn ' onClick={() => recoverExtraSaleModal(this.state.uoId, extraSaleMaster.id)}>
                                <i className='iDocIcon-undo-back' />
                              </a>
                            </OverlayTrigger>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <ExtraSaleModalPage uoId={this.state.uoId}/>
      </div>
    )
  }
}

export default ExtraSaleMasters
